const foreign_worker_query = (groupId) => `query {
  getForeignWorkerByGroupId(group_id:"${groupId}") {
  id,
  ForeignWorkerFormData {
    new_profile_fw_profile_name,
    new_profile_fw_first,
    new_profile_fw_last,
    new_profile_fw_alien_reg_number,
    new_profile_fw_dob,
    new_profile_fw_birth_country,
    new_profile_fw_middle,
    new_profile_fw_address,
    new_profile_fw_address2,
    new_profile_fw_city,
    new_profile_fw_state,
    new_profile_fw_postal_code,
    new_profile_fw_country,
    new_profile_fw_province,
    new_profile_fw_class,
    new_profile_fw_citizen_country,
    new_profile_fw_education{
      appAEduTypeId,
      appAEduOther,
      appAEduMajors,
      appAEduInstName,
      appAEduCountryId,
      appAEduMonthYearAttained,
    },
    new_profile_fw_training_qualifications{
      appATrainingInstName,
      appATrainingName,
      appATrainingCert,
      appATrainingStartDate,
      appATrainingEndDate,
      appATrainingYearAwd,
    },
    new_profile_fw_skills{
      appASkillsInstName,
      appASkillsCountryId,
      appASkillsStateId,
      fwTerritory,
      appASkillsSpecial,
    },
    new_profile_fw_work_experience{
      appAExpEmpName, 
      appAExpAddress1,
      appAExpAddress2,
      appAExpCity,
      appAExpPostalCode,
      appAExpCountryId,
      appAExpStateTerritory,
      appAExpProvince,
      appAExpJobTitle,
      appAExpStartDate,
      appAExpEndDate,
      appAExpFWPresent,
      appAExpWorkHour,
      appAExpJobDuties,
    }
  }
  }
  }
  `;

export default foreign_worker_query;
